import React, { useState } from "react";
import { MapPin, Mail, Send } from "lucide-react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { brand, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function Contact() {
  const { lang } = useLang();
  const c = translations[lang].contact;
  const f = c.form;
  const [form, setForm] = useState({ first: "", last: "", email: "", phone: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.first || !form.email || !form.message) { toast.error(f.err); return; }
    setSubmitting(true);
    setTimeout(() => { setSubmitting(false); toast.success(f.ok); setForm({ first: "", last: "", email: "", phone: "", subject: "", message: "" }); }, 900);
  };

  return (
    <section id="contact" className="py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <span className="text-sm font-bold uppercase tracking-widest text-cblue">{c.eyebrow}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{c.title}</h2>
          <p className="mt-4 text-slate-600 max-w-md">{c.subtitle}</p>
          <div className="mt-10 space-y-5">
            <div className="flex items-center gap-4">
              <div className="grid h-12 w-12 place-items-center rounded-xl bg-sky-tint"><MapPin className="h-5 w-5 text-cblue" /></div>
              <div>
                <p className="text-xs uppercase tracking-wide text-slate-400 font-semibold">{c.labelAddress}</p>
                <p className="text-navy font-medium">{c.address}</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="grid h-12 w-12 place-items-center rounded-xl bg-sky-tint"><Mail className="h-5 w-5 text-cblue" /></div>
              <div>
                <p className="text-xs uppercase tracking-wide text-slate-400 font-semibold">{c.labelEmail}</p>
                <a href={`mailto:${brand.email}`} className="text-navy font-medium hover:text-cblue transition-colors">{brand.email}</a>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="rounded-3xl border border-slate-100 bg-white p-7 md:p-9 shadow-sm">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label className="text-navy">{f.first}</Label><Input value={form.first} onChange={update("first")} className="mt-1.5 h-12" /></div>
            <div><Label className="text-navy">{f.last}</Label><Input value={form.last} onChange={update("last")} className="mt-1.5 h-12" /></div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            <div><Label className="text-navy">{f.email}</Label><Input type="email" value={form.email} onChange={update("email")} className="mt-1.5 h-12" /></div>
            <div><Label className="text-navy">{f.phone}</Label><Input value={form.phone} onChange={update("phone")} className="mt-1.5 h-12" /></div>
          </div>
          <div className="mt-4"><Label className="text-navy">{f.subject}</Label><Input value={form.subject} onChange={update("subject")} className="mt-1.5 h-12" /></div>
          <div className="mt-4"><Label className="text-navy">{f.message}</Label><Textarea value={form.message} onChange={update("message")} className="mt-1.5 min-h-[130px]" /></div>
          <Button type="submit" disabled={submitting} className="mt-6 w-full py-6 bg-navy hover:bg-navy-800 text-white rounded-full font-semibold text-base">
            {submitting ? f.sending : (<><Send className="mr-2 rtl:ml-2 rtl:mr-0 h-5 w-5" /> {f.send}</>)}
          </Button>
        </form>
      </div>
    </section>
  );
}
